import i18n from '../i18n/config';

const FETCH_ERROR_MARKERS = [
  'Failed to fetch',
  'NetworkError',
  'Network request failed',
  'Load failed',
];

const PERSIAN_SCRIPT_RE = /[\u0600-\u06FF\u0750-\u077F\uFB50-\uFDFF\uFE70-\uFEFF]/;

/** True when the browser could not reach the API (offline, CORS, server down). */
export function isFetchError(error) {
  const msg = String(error?.message || error || '');
  return FETCH_ERROR_MARKERS.some((marker) => msg.includes(marker));
}

function shouldIgnoreBackendMessage(message) {
  const lang = i18n.language?.split('-')[0];
  if (lang === 'fa') return false;
  return PERSIAN_SCRIPT_RE.test(String(message || ''));
}

/** Localize raw API/backend message for the active UI language. */
export function localizeApiMessage(message, t, fallbackKey = 'common.genericError') {
  const translate = t || ((key) => i18n.t(key));
  if (!message) return translate(fallbackKey);
  if (shouldIgnoreBackendMessage(message)) return translate(fallbackKey);
  return message;
}

export function fetchErrorMessage(error, fallbackKey = 'auth.connectionError', t) {
  const translate = t || ((key) => i18n.t(key));
  if (isFetchError(error)) {
    return translate('auth.connectionError');
  }
  const msg = error?.message;
  if (msg) {
    if (shouldIgnoreBackendMessage(msg)) {
      return translate(fallbackKey);
    }
    return msg;
  }
  return translate(fallbackKey);
}

/** Normalize error for re-throw after translation. */
export function toFetchAwareError(error, fallbackKey = 'auth.connectionError', t) {
  return new Error(fetchErrorMessage(error, fallbackKey, t));
}
